import { normalizeString } from "../functions"

const contributionSchema = {
	planId: (planId) => planId,
	fundingSource: (fundingSource) => fundingSource,
	event: (event) => normalizeString({ data: event, actions: ["spacing"] }),
	amount: (amount) => amount,
	taxYear: (taxYear) => Number(taxYear),
	value: (value) => value,
	period: (value) => value,
	isRollover: (isRollover) => isRollover || false
}

export default contributionSchema
